import UserCognitoService from '../../services/controllers/user/UserCognitoService';

export const routes = {
  DEFAULT: '/',
  LIBRARY: '/library',
  LIBRARY_ARCHIVE: '/library/archive',
  USER_MANAGEMENT: '/user-management',
  ACCOUNT_MANAGEMENT: '/account-management/:child',
  HELP_AND_SUPPORT: '/help-and-support',
  REFERRALS: '/referrals',
  SETTING: '/setting',
  PROFILE: '/profile',

  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT: '/forgot',
  RESET_PASSWORD: '/reset-password',
  VERIFY_ACCOUNT: '/verify',

  CREATE_BOOK: '/book/create/:id',
  CREATE_BOOK_HELP_AND_SUPPORT: '/book/create/help-and-support',

  LANDING_PAGE: '/landing-page',

  POLICIES_TERMS: '/policies/terms-of-use',
  POLICIES_PRIVACY: '/policies/privacy',

  TEMPLATES: '/templates',

  MOBILE_UPLOAD: '/transfer/:id',

  GUEST_MOBILE_UPLOAD: '/guest/upload/:id',
};

export interface RouteGuard {
  /**
   * If the condition is not met then either redirect to onFail or don't render the route
   */
  failCondition: boolean;
  /**
   * If request is still in progress we don't want to call onFail yet
   */
  requestDone: boolean;
  /**
   * URL where to redirect to, when condition is not met
   */
  onFail?: string | null;
}

export const unAuthGuard: RouteGuard = {
  failCondition: !!UserCognitoService.cognitoUser,
  requestDone: true,
  onFail: routes.DEFAULT,
};

export const authGuard: RouteGuard = {
  failCondition: !UserCognitoService.cognitoUser,
  requestDone: true,
  onFail: routes.LOGIN,
};
